export const SubtractLarge = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 16L27 16" stroke="currentColor" stroke-width="2"/>
</svg>`;
